import httpProvider from 'Providers/http.js'

export default {
  getBlePasses(cuid, filters = {}) {
    return new Promise((resolve, reject) => {
      httpProvider
        .get(
          `/contact-config/${cuid}/ble-passes?` +
            new URLSearchParams(filters).toString()
        )
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadBlePasses(cuid, formData) {
    return new Promise((resolve, reject) => {
      httpProvider
        .post(`/contact-config/${cuid}/ble-passes/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
